export default __webpack_public_path__ + "static/media/Ode To Joy.ce32bb09.png";